import {
  TypographyVariant,
  FontWeight,
} from '../components/Styled/types/TypographyTypes';
import {
  variantMapping,
  fontWeightMapping,
} from '../components/Styled/types/TypographyConstants';

// Helper function to get font size for a variant
export const getFontSize = (variant: TypographyVariant): string => {
  return variantMapping[variant];
};

// Helper function to get font weight
export const getFontWeight = (fontWeight: FontWeight): string => {
  return fontWeightMapping[fontWeight];
};

// Helper function to get the HTML element for a variant
export const getVariantElement = (
  variant: TypographyVariant
): React.ElementType => {
  if (variant === 'h1') return 'h1';
  if (variant === 'h2') return 'h2';
  if (variant === 'h3') return 'h3';
  if (variant === 'h4') return 'h4';
  if (
    variant === 'subtitle1' ||
    variant === 'subtitle2' ||
    variant === 'subtitle3'
  )
    return 'h5';
  if (
    variant === 'overline1' ||
    variant === 'overline2' ||
    variant === 'overline3'
  )
    return 'h6';
  if (
    variant === 'body1' ||
    variant === 'body2' ||
    variant === 'caption1' ||
    variant === 'caption2'
  )
    return 'p';
  // Default fallback
  return 'p';
};
